import { createContext, useContext } from 'react';

import { GuestStatus } from 'types/guest.types';
import { PlusOneGuest } from 'types/plus-one.types';
import { QuestionResponse } from 'types/question-response.types';
import { EventForRSVPControl, GuestForRSVPControl } from 'types/rsvp_control.types';

export interface PlusOneRsvpControlModalNavContextType {
  currentStepNumber: number;
  totalStepNumber: number;
  loading: boolean;
  onCancel: () => void;
  onClickBack: () => void;
  onClickSubmit: () => void;
}

export interface PlusOneRsvpControlModalContextType {
  // navigation
  navigation: PlusOneRsvpControlModalNavContextType;

  ownerGuest: GuestForRSVPControl;
  plusOneGuest: PlusOneGuest;
  eventOrSessionId: number;
  event: EventForRSVPControl;

  // status (passed as prop, not changeable)
  selectedStatus: GuestStatus;

  // plus one questionnaire
  requiresPlusOneQuestionnaireSubmission: boolean;
  updatedResponses: QuestionResponse[];
  setUpdatedResponses: (updatedResponses: QuestionResponse[]) => void;

  // owner (owner guest) questionnaire
  requiresOwnerQuestionnaireSubmission: boolean;
  updatedOwnerResponses: QuestionResponse[];
  setUpdatedOwnerResponses: (updatedOwnerResponses: QuestionResponse[]) => void;

  // notifications
  sendNotifications: boolean;
  setSendNotifications: (value: boolean) => void;
}

export const PlusOneRsvpControlModalContext = createContext<
  PlusOneRsvpControlModalContextType | undefined
>(undefined);

export const usePlusOneRsvpControlModalContext = (): PlusOneRsvpControlModalContextType => {
  const context = useContext(PlusOneRsvpControlModalContext);
  if (!context)
    throw new Error('usePlusOneRsvpControlModalContext can only be used inside a provider');
  return context;
};
